import BeforeAfterSlider from "@/components/BeforeAfterSlider";

export const AiLogoExample = () => (
  <section className="border-b border-black/5" data-testid="ai-example-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
      <div className="md:col-span-5">
        <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#52525B] mb-3">Real example</div>
        <h2 className="text-3xl md:text-4xl tracking-tighter font-black leading-[1.05] mb-6">
          From AI image<br /><span className="text-[#ED5A24]">to real artwork.</span>
        </h2>
        <p className="text-base text-[#52525B] leading-relaxed mb-4">
          This sample logo was made with an AI image tool and saved as a small, low-res picture. Drag the slider to see what Pesky Pixel turned it into: clean, sharp-edged vector shapes you can scale to any size.
        </p>
        <p className="text-xs text-[#52525B] italic">Sample brand made for demonstration only.</p>
      </div>
      <div className="md:col-span-7">
        <div className="border border-black/10 max-w-xl mx-auto" data-testid="ai-example-slider">
          <BeforeAfterSlider
            beforeSrc="/sample-ai-before.png"
            afterSrc="/sample-ai-after.png"
            beforeLabel="AI image · 220px"
            afterLabel="Vector"
            bgChecker={false}
          />
        </div>
      </div>
    </div>
    <SampleBrandGuide />
  </section>
);

const SampleBrandGuide = () => (
  <div className="max-w-7xl mx-auto px-6 lg:px-8 pb-20 md:pb-28 grid grid-cols-1 md:grid-cols-12 gap-10 items-center" data-testid="sample-brand-guide">
    <div className="md:col-span-7 md:order-2">
      <a href="/sample-brand-guide.pdf" target="_blank" rel="noreferrer" className="block border border-black/10 shadow-sm max-w-md mx-auto hover:-translate-y-1 transition-transform duration-300" data-testid="sample-brand-guide-image-link">
        <img src="/sample-brand-guide.png" alt="Sample one-page brand guidelines for Ember Roast" className="w-full h-auto block" loading="lazy" />
      </a>
    </div>
    <div className="md:col-span-5 md:order-1">
      <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#52525B] mb-3">Included</div>
      <h3 className="text-2xl md:text-3xl tracking-tighter font-black leading-[1.05] mb-5">Plus a one-page brand guide.</h3>
      <p className="text-base text-[#52525B] leading-relaxed mb-6">
        The same logo, with its exact colour codes (HEX, RGB, CMYK), matched free fonts, clear-space rules and do's and don'ts, all on one page you can hand to a printer or designer.
      </p>
      <a href="/sample-brand-guide.pdf" target="_blank" rel="noreferrer" data-testid="sample-brand-guide-pdf-link"
        className="inline-flex items-center border border-[#0A0A0B] hover:bg-[#0A0A0B] hover:text-white text-xs uppercase tracking-[0.2em] font-bold h-11 px-6 transition-colors duration-200">
        View sample PDF
      </a>
    </div>
  </div>
);
